import {SvgIcon, SvgIconProps} from "@mui/material";
import {FC} from "react";

const SvgIconDALINK: FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        <svg
            viewBox="0 0 34 40"
        >
            <defs>
                <linearGradient id="dalink" x1="86.328%" x2="8.51%" y1="11.463%" y2="100%">
                    <stop offset="0%" stopColor="#F59C07" />
                    <stop offset="100%" stopColor="#F57507" />
                </linearGradient>
            </defs>
            <path
                fill="url(#dalink)"
                d="M25.317 0c.498 0 .945.2 1.293.602l7.06 8.27c.25.351.398.802.299 1.203l-1.044 12.28c-.05.401-.199.753-.497 1.053l-8.701 8.522c-.299.35-.697.5-1.144.5h-9.248L5.181 40l.646-7.57H1.7c-.497 0-.895-.2-1.243-.55a1.63 1.63 0 0 1-.447-1.304L2.545 1.504C2.645.652 3.34 0 4.236 0zM8.77 15.68a6 6 0 0 0-1.771 4.275c0 1.615.63 3.134 1.77 4.276A6 6 0 0 0 13.045 26a6 6 0 0 0 4.274-1.77l2.617-2.616-1.68-1.68-2.615 2.615c-1.387 1.386-3.804 1.387-5.192 0a3.64 3.64 0 0 1-1.074-2.594c0-.98.38-1.901 1.074-2.595l2.617-2.616-1.68-1.68zm3.328 3.543 1.678 1.678 7.126-7.125-1.68-1.678zm7.858-12.224a6 6 0 0 0-4.275 1.77l-2.616 2.616 1.68 1.68 2.615-2.615a3.64 3.64 0 0 1 2.596-1.076c.98 0 1.901.38 2.595 1.074a3.65 3.65 0 0 1 1.074 2.596c0 .98-.38 1.901-1.074 2.595l-2.616 2.616 1.68 1.68 2.616-2.617A6 6 0 0 0 26 13.044a6 6 0 0 0-1.77-4.275 6 6 0 0 0-4.274-1.77"
            />
        </svg>
    </SvgIcon>
)

export default SvgIconDALINK
